export default __webpack_public_path__ + "static/savings-strategy-46dc9a1e6d111d37e77a84528d34185b.jpg";